import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Grid, Typography, InputAdornment, IconButton } from "@mui/material";

import { Paper, TextField, Label } from "../../../components";
import {
  PrimaryLoadingButton,
  CancelButton,
} from "../../css components/Button";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);

  return (
    <Paper style={{ width: "600px", paddingTop: "50px", margin: "auto" }}>
      <Grid item xs={12}>
        <Typography variant="h2">Ready?</Typography>

        <Typography variant="h3" color="#BDBDBD">
          Sign-Up Now
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Label title={"Given Name"} />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          name="givenName"
          formikProps={formikProps}
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Enter given name"
        />
      </Grid>

      <Grid item xs={6}>
        <Label title={"Family Name"} />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          name="familyName"
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Enter family name"
          formikProps={formikProps}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title={"Display Name"} />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          name="displayName"
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Enter display name"
          formikProps={formikProps}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title={"Email Address"} />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          name="email"
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Enter email address"
          formikProps={formikProps}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title={"Password"} />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          type={showPassword ? "text" : "password"}
          name="password"
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Enter password"
          formikProps={formikProps}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {!showPassword && <VisibilityOff />}
                  {showPassword && <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title={"Re-Enter Password"} />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          type={confirmPassword ? "text" : "password"}
          name="confirmPassword"
          inputProps={{ "aria-label": "Without label" }}
          placeholder="Enter password"
          formikProps={formikProps}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => setConfirmPassword(!confirmPassword)}
                >
                  {!confirmPassword && <VisibilityOff />}
                  {confirmPassword && <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {/* <Grid item xs={6}>
        <Label title={"Secure Key"} />
      </Grid>

      <Grid item xs={8}>
        <TextField
          name="key"
          placeholder="Enter Secure Key"
          formikProps={formikProps}
        />
      </Grid>

      <Grid
        item
        xs={4}
        alignItems="stretch"
        style={{ textAlign: "center", alignSelf: "center" }}
      >
        <div
          style={{
            background: "#333",
            color: "#fff",
            padding: "16px 0",
            borderRadius: "5px",
          }}
        >
          <Typography>AHJGAQJH</Typography>
        </div>
      </Grid> */}

      <Grid item xs={12}>
        <Typography variant="caption1">
          Already have account?{" "}
          <Typography
            variant="button"
            color="#00BEFF"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/sign-in")}
          >
            Sign In!
          </Typography>
        </Typography>
      </Grid>

      <Grid item xs></Grid>

      <Grid item>
        <CancelButton variant="outlined" onClick={() => navigate(-1)}>
          Cancel
        </CancelButton>
      </Grid>

      <Grid item>
        <PrimaryLoadingButton
          type="submit"
          variant="contained"
          fullWidth
          onClick={formikProps.handleSubmit}
          disabled={!formikProps.dirty || !formikProps.isValid}
          loading={formikProps.isSubmitting}
        >
          Sign Up
        </PrimaryLoadingButton>
      </Grid>
    </Paper>
  );
}
